(function () {
  const modalSelector = "[data-modal]";
  const openSelector = "[data-modal-open]";
  const closeSelector = "[data-modal-close]";
  let activeModal = null;
  let previousFocus = null;
  let originalParent = null; // Track where modal came from

  const getFocusableElements = (modal) =>
    Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    );

  const openModal = (modal) => {
    if (!modal) {
      return;
    }

    previousFocus = document.activeElement;
    activeModal = modal;

    // FIX: Move modal to body to escape transformed parents
    if (modal.parentElement !== document.body) {
      originalParent = modal.parentElement;
      document.body.appendChild(modal);
    }

    modal.classList.add("site-modal--open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("has-modal-open");
    document.body.classList.add("has-modal-open");

    const dialog = modal.querySelector(".site-modal__dialog");
    const focusable = getFocusableElements(modal);
    (focusable[0] || dialog || modal).focus();
  };

  const closeModal = (modal) => {
    if (!modal) {
      return;
    }

    modal.classList.remove("site-modal--open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("has-modal-open");
    document.body.classList.remove("has-modal-open");

    // FIX: Return modal to original parent when closed
    if (originalParent && modal.parentElement === document.body) {
      originalParent.appendChild(modal);
      originalParent = null;
    }

    if (previousFocus && typeof previousFocus.focus === "function") {
      previousFocus.focus();
    }

    activeModal = null;
    previousFocus = null;
  };

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest(openSelector);
    const closeButton = event.target.closest(closeSelector);

    if (openButton) {
      event.preventDefault();
      openModal(
        document.getElementById(openButton.getAttribute("data-modal-open")),
      );
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest(modalSelector));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (!activeModal) {
      return;
    }

    if (event.key === "Escape") {
      closeModal(activeModal);
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusable = getFocusableElements(activeModal);

    if (!focusable.length) {
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
